import { DestroyRef, inject, signal, type Signal } from '@angular/core';

/**
 * Cadência do relógio do selo de SLA.
 *
 * Cinco segundos porque as metas de IA são cravadas em SEGUNDOS ("responder em 30s"): num tique de
 * minuto, um selo verde de "28s" atravessaria o estouro inteiro sem mudar de cor.
 */
const TICK_MS = 5_000;

/**
 * Signal que reemite o instante atual periodicamente.
 *
 * Existe porque `computeSlaBadge` recebia `now = new Date()` dentro de um `computed`: `new Date()`
 * não é signal, então o `computed` memoizava e o selo NUNCA recalculava pela passagem do tempo. Um
 * turno estourava, o painel registrava a violação, e a tela do atendente seguia verde com o mesmo
 * número congelado — e o filtro "risco de SLA" também não detectava nada com a tela aberta.
 *
 * Registra `clearInterval` no `DestroyRef` do injetor que o criou, então não há timer órfão.
 */
export function createNowSignal(tickMs: number = TICK_MS): Signal<Date> {
  const destroyRef = inject(DestroyRef);
  const now = signal(new Date());
  const handle = setInterval(() => now.set(new Date()), tickMs);
  destroyRef.onDestroy(() => clearInterval(handle));
  return now.asReadonly();
}
